import React from "react";

import { AiSideNavBarBody } from "@src/components/Navigation/AiSideNav/AiSideNavBarBody";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { useSelector } from "@src/store";

export const AiSideNav = () => {
  const sideNavCollapsed = useSelector(
    (state) => state.appSettings.sideNavCollapsed
  );

  return (
    <NavigationDrawer
      isUnauthorized={false}
      hideOrgPicker={true}
      customBody={<AiSideNavBarBody drawerOpen={!sideNavCollapsed} />}
      customFooter={null}
    />
  );
};
